import React from "react";
import { TLabel } from "./types";
import Tooltip from "@/components/tooltip";
import { innerText } from "@/helpers/UtilityHelper";

const Label = (props: TLabel) => {
    const { id, label, title, tooltip, type, options } = props;

    if ((innerText(label)?.length ?? 0) === 0 && !options?.label?.force) {
        return null;
    }

    return (
        <label htmlFor={id} title={title} data-type={type ?? (tooltip ? "" : "inline")}>
            { tooltip && <Tooltip className="md-hidden--hard lg-hidden--hard">{ tooltip }</Tooltip> }
            { (innerText(label)?.length ?? 0) === 0 ? <span className="sm-hidden--hard">&nbsp;</span> : label }
            { tooltip && <Tooltip className="ml-1 sm-hidden--hard">{ tooltip }</Tooltip> }
        </label>
    );
};

export default Label;
